module.exports = __webpack_public_path__ + "static/media/hero.6495b46d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/crescent-extension/hero.jpg
// module id = 55
// module chunks = 0